import { X } from "lucide-react";

export function Modal({ title, eyebrow, close, children, testId, wide = false }) {
  return (
    <div className="modal-backdrop" onClick={close}>
      <div
        className={`modal-card ${wide ? "modal-wide" : ""}`}
        role="dialog"
        onClick={(event) => event.stopPropagation()}
        data-testid={testId}
      >
        <div className="modal-heading">
          <div>
            {eyebrow ? <p className="hero-label">{eyebrow}</p> : null}
            <h2>{title}</h2>
          </div>
          <button
            type="button"
            className="icon-button"
            onClick={close}
            aria-label="Close dialog"
            data-testid={`${testId}-close-button`}
          >
            <X size={20} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function ConfirmDialog({ title, message, onCancel, onConfirm, confirmLabel = "Confirm", danger = false, testId = "confirm-dialog" }) {
  return (
    <Modal title={title} eyebrow="CONFIRMATION" close={onCancel} testId={testId}>
      <p style={{ color: "#475569", marginBottom: 16 }}>{message}</p>
      <div className="modal-actions">
        <button type="button" className="button button-outline" onClick={onCancel} data-testid={`${testId}-cancel`}>
          Cancel
        </button>
        <button
          type="button"
          className={`button ${danger ? "button-danger" : "button-primary"}`}
          onClick={onConfirm}
          data-testid={`${testId}-confirm`}
        >
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
